<script setup lang="ts">
import { computed } from 'vue';

import BaseIcon from '@/components/base/BaseIcon.vue';
import type { IconSize } from '@/utils/svg';

const props = withDefaults(
  defineProps<{
    size?: IconSize | [IconSize, IconSize];
    direction?: 'up' | 'down' | 'left' | 'right';
  }>(),
  {
    size: 24 as IconSize,
    direction: 'down',
  },
);

const directionClass = computed(() => {
  switch (props.direction) {
    case 'up':
      return 'transform rotate-180';
    case 'down':
      return 'transform rotate-0';
    case 'left':
      return 'transform rotate-90';
    case 'right':
      return 'transform -rotate-90';
    default:
      return '';
  }
});
</script>

<template>
  <BaseIcon :size="size" viewBox="0 0 24 24" fill="none" :class="directionClass">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5 20.9956C7.44503 20.9956 3.36303 16.8276 3.50403 11.7406C3.63403 7.04464 7.54903 3.12964 12.245 2.99964C17.332 2.85864 21.5 6.94064 21.5 11.9956C21.5 13.3526 21.199 14.6396 20.662 15.7946L21.82 21.3376L16.287 20.1626C15.135 20.6976 13.852 20.9956 12.5 20.9956V20.9956Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.6768 11.8232C12.7744 11.9209 12.7744 12.0791 12.6768 12.1768C12.5791 12.2744 12.4209 12.2744 12.3232 12.1768C12.2256 12.0791 12.2256 11.9209 12.3232 11.8232C12.4209 11.7256 12.5791 11.7256 12.6768 11.8232"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.6768 11.8232C16.7744 11.9209 16.7744 12.0791 16.6768 12.1768C16.5791 12.2744 16.4209 12.2744 16.3232 12.1768C16.2256 12.0791 16.2256 11.9209 16.3232 11.8232C16.4209 11.7256 16.5791 11.7256 16.6768 11.8232"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.67678 11.8232C8.77441 11.9209 8.77441 12.0791 8.67678 12.1768C8.57915 12.2744 8.42085 12.2744 8.32322 12.1768C8.22559 12.0791 8.22559 11.9209 8.32322 11.8232C8.42085 11.7256 8.57915 11.7256 8.67678 11.8232"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </BaseIcon>
</template>
